import apiClient from './apiClient';

// F10H interface matching backend model
export interface F10H {
  f10h_01: string;   // 廠商代號
  f10h_02: string;   // 類別
  f10h_03: string | null;  // 申請日期
  f10h_10: string;   // 公司代號
  f10h_11: string;   // 簡稱
  f10h_12: string;   // 全名
  f10h_13: string;   // 英文名稱
  f10h_14: string;   // 國碼
  f10h_15: string | null;  // 日期欄位 (DATE in DB)
  f10h_16: number;   // 整數欄位 (INTEGER in DB)
  f10h_17: string;   // 資本額
  f10h_18: string;   // 營業項目
  f10h_20: string;   // 傳真
  f10h_21: string;   // 統一編號
  f10h_22: string;   // 公司電子郵件
  f10h_23: string;   // 網站
  f10h_24: string;   // 備註/摘要（Page3 editbox）
  f10h_30: string;   // 經辦人員
  f10h_31: string;   // 申請單位
  f10h_34: string;   // 帳號
  f10h_35: boolean;  // 布林旗標1 (BOOLEAN in DB)
  f10h_36: boolean;  // 布林旗標2 (BOOLEAN in DB)
  f10h_37: string;   // 部門代碼
  f10h_41: string;   // 廠商特性
  f10h_411: string;  // 廠商特性代碼
  f10h_42: string;   // 機器設備簡介
  f10h_421: string;  // 機器設備代碼
  f10h_43: string;   // 產能預估
  f10h_431: string;  // 產能預估代碼
  f10h_44: string;   // 樣品評核
  f10h_441: string;  // 樣品評核代碼
  f10h_45: string;   // 其他
  f10h_451: string;  // 其他代碼
  f10h_46: boolean;  // ISO 9000 認證
  f10h_47: boolean;  // 專利權
  f10h_48: boolean;  // 獨占性廠商
  f10h_49: boolean;  // 上市上櫃
  f10h_51: string;   // 票款別
  f10h_52: number;   // 數值欄位 (NUMERIC in DB)
  f10h_80: string;   // 第一層核准狀態
  f10h_801: string;  // 部門核准人員
  f10h_802: string;  // 部門核准說明
  f10h_81: string;   // 第二層核准狀態
  f10h_811: string;  // 研發核准人員
  f10h_812: string;  // 研發核准說明
  f10h_82: string;   // 第三層核准狀態
  f10h_821: string;  // 總經理核准人員
  f10h_822: string;  // 總經理核准說明
  f10h_91: string;   // 建立人員代號
  f10h_92: string | null;  // 建立日期
  f10h_93: string;   // 最後異動人員代號
  f10h_94: string | null;  // 最後異動日期
  addresses: F10H1[];
  contacts: F10H2[];
  credit: F10H3 | null;
}

export interface F10H1 {
  f10h1_01: string;
  f10h1_02: number;
  f10h1_11: string;
  f10h1_12: string;
  f10h1_13: string;
  f10h1_14: string;
}

export interface F10H2 {
  f10h2_01: string;
  f10h2_02: string;   // 姓名
  f10h2_11: string;   // 職務
  f10h2_12: string;   // 職稱
  f10h2_13: string;   // 專線
  f10h2_14: string;   // 分機
  f10h2_15: string;   // 電子郵件
  f10h2_seq: number;
  // F103 cross-table fields (名片/聯絡人個人資料)
  f103_01?: string;   // 姓名 (readOnly)
  f103_12?: string;   // 英文姓名
  f103_14?: string;   // 性別
  f103_21?: string;   // 聯絡電話
  f103_22?: string;   // 行動電話
}

export interface F10H3 {
  f10h3_01: string;
  f10h3_11: string;    // 幣別
  f10h3_13: string;    // 收款條件
  f10h3_131: string;   // 收款條件名稱
  f10h3_14: string;    // 付款條件
  f10h3_141: string;   // 付款條件名稱
  f10h3_16: string;    // 往來銀行
  f10h3_161: number;   // 付款銀行選擇
  f10h3_162: string;   // 帳號
  f10h3_17: string;    // 往來銀行2
  f10h3_171: number;   // 收款銀行選擇
  f10h3_172: string;   // 帳號2
  f10h3_21: number;
  f10h3_22: number;
  f10h3_23: string | null;   // 採購擔保起日 (DATE in DB)
  f10h3_24: string | null;   // 採購擔保迄日 (DATE in DB)
  f10h3_25: string;          // 擔保方式（採購）
  f10h3_26: number;
  f10h3_27: number;
  f10h3_31: number;
  f10h3_32: number;
  f10h3_33: string | null;   // 受訂擔保起日 (DATE in DB)
  f10h3_34: string | null;   // 受訂擔保迄日 (DATE in DB)
  f10h3_35: string;          // 擔保方式（受訂）
  f10h3_36: number;
  f10h3_37: number;
  avail_order_balance: number;
  avail_ship_balance: number;
  avail_purchase_balance: number;
  avail_receive_balance: number;
}

export interface ListResponse {
  data: F10H[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  code: string;
  message: string;
}

const BASE = '/api/vendor-eval';

const vendorEvalApi = {
  list: async (page = 1, size = 100, keyword?: string): Promise<ListResponse> => {
    if (keyword) {
      const res = await apiClient.get(`${BASE}/search`, { params: { keyword, page, size } });
      return res.data;
    }
    const res = await apiClient.get(BASE, { params: { page, size } });
    return res.data;
  },

  search: async (keyword: string, page = 1, size = 20): Promise<ListResponse> => {
    const res = await apiClient.get(`${BASE}/search`, { params: { keyword, page, size } });
    return res.data;
  },

  get: async (code: string): Promise<F10H> => {
    const res = await apiClient.get(`${BASE}/${encodeURIComponent(code)}`);
    return res.data;
  },

  create: async (data: Partial<F10H>): Promise<F10H> => {
    const res = await apiClient.post(BASE, data);
    return res.data;
  },

  update: async (code: string, data: Partial<F10H>): Promise<F10H> => {
    const res = await apiClient.put(`${BASE}/${encodeURIComponent(code)}`, data);
    return res.data;
  },

  delete: async (code: string): Promise<void> => {
    await apiClient.delete(`${BASE}/${encodeURIComponent(code)}`);
  },

  // Approval workflow
  submitForApproval: async (id: string, comment?: string): Promise<ApprovalResponse> => {
    const res = await apiClient.post(`${BASE}/${encodeURIComponent(id)}/submit`, { comment: comment || '' });
    return res.data;
  },

  approve: async (id: string, comment?: string): Promise<ApprovalResponse> => {
    const res = await apiClient.post(`${BASE}/${encodeURIComponent(id)}/approve`, { comment: comment || '' });
    return res.data;
  },

  reject: async (id: string, comment?: string): Promise<ApprovalResponse> => {
    const res = await apiClient.post(`${BASE}/${encodeURIComponent(id)}/reject`, { comment: comment || '' });
    return res.data;
  },

  writeoff: async (id: string, comment?: string): Promise<ApprovalResponse> => {
    const res = await apiClient.post(`${BASE}/${encodeURIComponent(id)}/writeoff`, { comment: comment || '' });
    return res.data;
  },

  getApprovalHistory: async (id: string): Promise<ApprovalHistory[]> => {
    const res = await apiClient.get(`${BASE}/${encodeURIComponent(id)}/approval-history`);
    return res.data.data || [];
  },
};

export interface ApprovalResponse {
  order_no: string;
  action: string;
  old_status: string;
  new_status: string;
  message: string;
}

export interface ApprovalHistory {
  id: number;
  order_no: string;
  action: string;
  actor_id: string;
  actor_name: string;
  comment: string;
  old_status: string;
  new_status: string;
  created_at: string;
}

export default vendorEvalApi;
